"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import {
  isExperienceType,
  persistExperienceType,
  readExperienceType,
} from "./experience-type-storage";

export type TrackingEventProps = Record<string, unknown>;

type SendTrackingEventOptions = {
  eventName: string;
  page: string;
  eventProps: TrackingEventProps;
};

export function sendTrackingEvent({
  eventName,
  page,
  eventProps,
}: SendTrackingEventOptions) {
  const experienceTypeFromProps =
    "experience_type" in eventProps &&
    typeof eventProps.experience_type === "string" &&
    isExperienceType(eventProps.experience_type)
      ? eventProps.experience_type
      : undefined;

  const experienceType =
    experienceTypeFromProps ??
    (eventName === "purchase" ? readExperienceType() : undefined);

  if (experienceTypeFromProps) {
    persistExperienceType(experienceTypeFromProps);
  }

  sendGTMEvent({
    event: eventName,
    page,
    ...eventProps,
    ...(experienceType && { experience_type: experienceType }),
  });
}
